import DashboardNotificationContainer from './dashboard-notification-container'
import DashboardNotificationActionBarView from './components/dashboard-notification-action-bar/dashboard-notification-action-bar-view'

export {
  DashboardNotificationActionBarView
}
export default DashboardNotificationContainer
